import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import "./a11yOnly.css";
/**
 * @see [LMDS A11yOnly Documentation and Examples](https://designsystem.lmig.com/components/a11y/code)
 *
 * API:
 *
 * @implements [A11yOnlyProps](https://designsystem.lmig.com/components/a11y/code#a11yonly-props)
 * @extends [HTMLSpanElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmlspanelement.html)
 */
export var A11yOnly = function A11yOnly(props) {
  var children = props.children,
    className = props.className,
    nativeProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classNames('lmig-A11yOnly', className)
  }, nativeProps), children);
};
A11yOnly.propTypes = {
  /**
     * Add a custom class to this element: `<span class="lmig-A11yOnly">`.
     */
  className: _pt.string,
  /**
     * Screen-reader only content that renders in this element: `<span class="lmig-A11yOnly">`
     */
  children: _pt.node.isRequired
};